import React from "react"
import byd from "../Assets/byd.png";
import kingkong from "../Assets/kingkong.png";
import electricride_logo from "../Assets/electricride_logo.png";
import panasonic from "../Assets/panasonic.png";
import catyl from "../Assets/catyl.png";
import tesla from "../Assets/tesla.png";



const Sponsors = () => {
    return(

        <div className="py-10 bg-white/10 ">
            <h2 className="text-center font-bold mb-6">AFFILIATE BRANDS</h2>
            <div className="flex flex-wrap justify-center align-middle items-center">
                <div><img src={byd} alt="" className="w-20" /></div>
                <div><img src={kingkong} alt="" className="w-20" /></div>
                <div><img src={electricride_logo} alt="" className="w-20" /></div>
                <div><img src={panasonic} alt="" className="w-20" /></div>
                <div><img src={catyl} alt="" className="w-20" /></div>
                <div><img src={tesla} className="w-20" alt="" /></div>

            </div>

        </div>
    )

}

export default Sponsors;